import React from "react";

const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (
        <footer>
            <p><b>Copyright © {currentYear} Ascension Counseling and Personal Development, LLC. All rights reserved.</b></p>
        </footer>
    );
};

export default Footer;
